export interface FileInfoBO {
  contentType: string;
  domainId: string;
  fileId: string;
  fileName: string;
  permission: Permission;
  size: number;
  shareId: string;
  shareName: string; //分享者名字
  shareOpen: boolean;
  expire: boolean;
  expireType: ExpireType; // 有效事件
  scanUrl: string; // 扫码登录的地址
}

export enum ExpireType {
  DAY = 1,
  WEEk,
  MONTH,
  PERMANAGE,
}

export enum Permission {
  VIEW = 1,
  DOWNLOAD = 3,
  EDIT = 5,
}

export interface PreviewBO {
  fileLimitSize: number;
  previewDomain: string;
  supports: string[];
}
